//export const feedbackFormLink = "https://goo.gl/forms/FaTEBShRKmZUNq162";
export const mailchimpSignupLink = "http://eepurl.com/bWw-R1";
// export const battle5DemoLink = "https://battle.thedangercrew.com";
// export const drewsTwitter = "https://twitter.com/drewconley13";
export const dangerCrewTwitter = "https://twitter.com/dangercrewgame";


export const steamPageLink = "https://store.steampowered.com/app/1064690/Danger_Crew";
export const itchPageLink = "https://dangercrewgame.itch.io/dangercrew";
export const pressKitLink = "https://presskit.thedangercrew.com/";